import type { ICompanyService } from "./ICompanyService";
import type { ApiReturnCompany } from "@highimpact-frontend/api-types";
import { api_config } from "../../../api-commons";

class CompanyService implements ICompanyService {
    async getCompanies(): Promise<ApiReturnCompany[]> {
        const response = await api_config.get('/companies');
        return response.data;
    }
}
const instance = new CompanyService();
export default instance;
